export type FETCH_USER = "bst/FETCH_USER";
export const FETCH_USER: FETCH_USER = "bst/FETCH_USER";

export type SET_USER = "bst/SET_USER";
export const SET_USER: SET_USER = "bst/SET_USER";

export type UPDATE_USER = "bst/UPDATE_USER";
export const UPDATE_USER: UPDATE_USER = "bst/UPDATE_USER";